var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-marker';
                    var viewUrl = 'sprite.svg#view-icon-marker';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-marker#icon-marker';
                            viewUrl = 'sprite.svg?icon-marker#view-icon-marker';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27.5 42.2',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };